// extracted by mini-css-extract-plugin
module.exports = {"container":"public-layout_container__P0jbi","main":"public-layout_main__pMzeJ","desktopOnly":"public-layout_desktopOnly__8iBiu"};